import { Col, Row } from "antd";
import React from "react";

const ComponentWithAdds = (props) => {
  const { componentFirst, className } = props;
  return (
    <Row className={className}>
      <Col md={18} sm={24} xs={24}>
        {componentFirst}
      </Col>
      <Col md={6} sm={24} xs={24}></Col>
    </Row>
  );
};

export default ComponentWithAdds;
